import React from 'react';
import { useMessages } from '../../i18n/locale';

export default function ProductVisual({ kind }) {
  const copy = useMessages().productVisual;
  if (kind === 'status')
    return (
      <div className="product-visual product-visual--status">
        <div className="mini-toolbar">
          <span />
          <span />
          <span />
          <em>{copy.status.toolbar}</em>
        </div>
        <div className="status-layout">
          <div className="status-sidebar">
            <i />
            <i />
            <i />
            <i />
          </div>
          <div className="status-main">
            <div className="status-topline">
              <span>{copy.status.overview}</span>
              <span className="live-pill">● {copy.status.operational}</span>
            </div>
            <div className="status-chart">
              <div className="chart-grid" />
              <svg viewBox="0 0 440 115" preserveAspectRatio="none" fill="none" aria-hidden="true">
                <path
                  d="M0 89 32 73 62 82 92 50 126 59 163 36 196 46 228 22 264 42 296 28 324 40 354 18 388 29 420 12 440 21"
                  stroke="#e8e8e8"
                  strokeWidth="2.5"
                />
                <path
                  d="M0 89 32 73 62 82 92 50 126 59 163 36 196 46 228 22 264 42 296 28 324 40 354 18 388 29 420 12 440 21V115H0Z"
                  fill="url(#chartFill)"
                />
                <defs>
                  <linearGradient id="chartFill" x1="0" y1="0" x2="0" y2="1">
                    <stop stopColor="#e8e8e8" stopOpacity=".22" />
                    <stop offset="1" stopColor="#e8e8e8" stopOpacity="0" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="status-metrics">
              <span>
                <b>99.98%</b>
                <small>{copy.status.metrics[0]}</small>
              </span>
              <span>
                <b>128ms</b>
                <small>{copy.status.metrics[1]}</small>
              </span>
              <span>
                <b>24/7</b>
                <small>{copy.status.metrics[2]}</small>
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  if (kind === 'writing')
    return (
      <div className="product-visual product-visual--writing">
        <div className="writing-sheet">
          <div className="writing-top">
            <span>◆ {copy.writing.space}</span>
            <span>● {copy.writing.saved}</span>
          </div>
          <div className="writing-title">
            {copy.writingTitle[0]}
            <br />
            {copy.writingTitle[1]}
            <span className="writing-cursor" />
          </div>
          <div className="writing-line writing-line--long" />
          <div className="writing-line" />
          <div className="writing-line writing-line--mid" />
          <div className="writing-highlight">✦ {copy.writingHighlight}</div>
        </div>
        <span className="writing-float">{copy.writing.float}</span>
      </div>
    );
  return (
    <div className="product-visual product-visual--task">
      <div className="task-board">
        <div className="task-board__title">
          {copy.task.workspace} <span>↗</span>
        </div>
        <div className="task-columns">
          <div>
            <small>
              {copy.task.todo} <b>03</b>
            </small>
            <span className="task-ticket">
              <i />
              {copy.task.strategy}
            </span>
            <span className="task-ticket">
              <i />
              {copy.task.designSystem}
            </span>
          </div>
          <div>
            <small>
              {copy.task.inProgress} <b>02</b>
            </small>
            <span className="task-ticket task-ticket--active">
              <i />
              {copy.task.buildExperience}
              <div className="ticket-progress">
                <span />
              </div>
            </span>
          </div>
          <div>
            <small>
              {copy.task.done} <b>08</b>
            </small>
            <span className="task-ticket">
              <i />
              {copy.task.initialIdea} ✓
            </span>
          </div>
        </div>
        <div className="task-board__timeline" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
